export const managerUsers = {
  usersList: {
    title: "Zarejestrowani użytkownicy",
    subtitle: "Lista użytkowników zarejestrowanych na platformie.",
    columns: {
      id: "ID",
      name: "Imię i nazwisko",
      phone: "Telefon",
      email: "E-mail",
      accommodations: "Obiekty",
      sends: "Wysyłki",
      checkin: "Check-in",
      registeredAt: "Data rejestracji",
    },
    states: {
      demo: "Wersja demo",
      demoEnded: "Demo zakończone",
      subscribed: "Subskrypcja aktywna",
      subscriptionExpired: "Subskrypcja wygasła",
      queryError: "Błąd zapytania",
    },
    deleteAdvisor: {
      confirmMessage: "Czy na pewno usunąć tego doradcę?",
      confirmHeader: "Potwierdzenie",
    },
  },
  accommodationUser: {
    info: "Szczegóły obiektu",
  },
  dataUserOld: {
    accommodationsList: "Lista obiektów",
    createAccommodation: "Utwórz obiekt",
    emptyMessage: "Brak zarejestrowanych obiektów",
    emptySubMessage: "Tutaj pojawią się obiekty zarejestrowane przez użytkownika.",
  },
  checkins: {
    title: "Zakończone check-iny",
  },
  checkinsPending: {
    title: "Check-iny oczekujące lub w trakcie",
  },
};
